<template>
  <div
    data-target="#assignModal"
    data-toggle="modal"
    class="card card-item card-preview card-item-list-layout"
    data-tooltip-content="#tooltip_content_1"
  >
    <!-- end card-image -->
    <div class="card-body">
      <div class="d-flex justify-content-center align-items-center">
        <h4 class="fs-20">پروژه ای با فیلترهای انتخاب شده پیدا نشد.</h4>
      </div>
    </div>
    <!-- end card-body -->
  </div>
</template>

<script>
export default {
  name: "NoArticle",
};
</script>

<style></style>
